// src/components/ui/globe/globeFeatures.ts

export const globeFeatures = [
    {
      name: "Global Insights",
      description:
        "Seamless cross-channel access to performance data, enhancing your marketing strategies and ad effectiveness."
    },
    {
      name: "Unified Teams",
      description:
        "Break down silos with aggregated performance metrics on every channel, providing a holistic view of your ads."
    },
    {
      name: "Drive Performance",
      description:
        "Discover hidden drivers performance with AI ad analytics, gaining actionable insights to optimize creative elements and ROAS."
    }
  ] as const
